/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it
import "./src/styles/main.scss"
import { applyTheme, getPreferredTheme } from "./src/utils/theme"

export const onClientEntry = () => {
  applyTheme(getPreferredTheme())
}
